/**
 * @flow
 * @author: Chinmaya
 */

import React from 'react'

type Props = {}

class CloseIcon extends React.Component<Props> {
  // constructor(){
  //   super()
  //   state = {
  //     mouseOverFillColor: ""
  //   }
  // }

  // onMouseOver = () => {
  //   this.
  // }

  render() {
    const { width, height, fillColor, className } = this.props
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 14 14"
      >
        <g fill="none" fillRule="evenodd">
          <path d="M-5-5h24v24H-5z" />
          <path
            fill={fillColor}
            d="M14 1.41L12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7z"
          />
        </g>
      </svg>
    )
  }
}

CloseIcon.defaultProps = {
  width: 14,
  height: 14,
  fillColor: '#FFF'
}

export default CloseIcon



// WEBPACK FOOTER //
// ./src/components/Home/GalleryHome/icons/CloseIcon/index.js